export default __webpack_public_path__ + "static/media/031-square ruler.a80c47a8.svg";